import React, { useContext } from 'react';
import { Loader } from 'ncoded-component-library';
import BuySide from '../BuySide';
import SellSide from '../SellSide';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';
import { useLockScrollOnParamsReroute } from 'hooks/useLockScrollOnParamsReroute';

const MembersDesktop: React.FC = () => {
  const { isLoading } = useContext(MembersContext);

  // Every control on both tables (page, sort, filters) lives in a query param,
  // and the global ScrollTo provider jumps the page to the top on any param
  // change. Paging scrolls to the top of the table that was paged instead; the
  // rest should not move the page at all.
  useLockScrollOnParamsReroute();

  return (
    <div className="members__container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <BuySide />
          <SellSide />
        </>
      )}
    </div>
  );
};

export default MembersDesktop;
